module.exports = __webpack_public_path__ + "static/media/29BDOS23.9237f596.jpg";